import { ChannelsInteractive } from './ChannelsInteractive';

export default ChannelsInteractive;
